
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/be2a4b35168daa017c531f0b361bded6.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="text-white">
            <p className="text-xs uppercase tracking-widest mb-10 text-white/80">
              iOS Development Experts
            </p>
            <h1 className="text-7xl font-bold leading-tight mb-8" style={{ fontFamily: 'Georgia, serif' }}>
              Modern Applications<br />
              For Enhanced Security<br />
              And User Experience
            </h1>
            <p className="text-lg leading-relaxed text-white/90 max-w-lg">
              Specializing in VPN and Cleaner solutions for iOS platform. Our products are designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative w-full h-96">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%203D%20rendered%20iPhone%20mockup%20floating%20at%20angle%20showcasing%20modern%20iOS%20app%20interface%20with%20VPN%20and%20security%20features%20clean%20minimalist%20design%20with%20soft%20blue%20and%20purple%20gradient%20background%20and%20subtle%20particle%20effects%20representing%20data%20protection%20and%20digital%20security&width=600&height=800&seq=hero-device-jamnik&orientation=portrait"
                alt="iOS Device Mockup"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}